/* FG Edwards product page: "Va avec" (complementary products with quick add) and the loyalty line.
   docs/pdp/03-pdp-audit.md, phase 3. Markup in snippets/fg-pdp-crosssell.liquid and snippets/fg-fastbuy.liquid. */
(function () {
  'use strict';
  if (window.__fgPdp) return;
  window.__fgPdp = 1;

  var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/').replace(/\/?$/, '/');

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, format) {
    var n = Number(cents) / 100;
    if (isNaN(n)) return '';
    var fixed = n.toFixed(2), whole = fixed.split('.')[0], dec = fixed.split('.')[1];
    var th = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return th(whole, '.') + ',' + dec;
      if (k === 'amount_no_decimals') return th(String(Math.round(n)), ',');
      if (k === 'amount_with_space_separator') return th(whole, ' ') + ',' + dec;
      return th(whole, ',') + '.' + dec;
    });
  }
  function send(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function firstWord(t) { return String(t || '').trim().split(/\s+/)[0].toLowerCase(); }

  /* ---------- "Va avec" ---------- */
  function goesWith(box) {
    var list = box.querySelector('[data-fg-goes-list]');
    var id = box.getAttribute('data-product-id');
    if (!list || !id) return;
    var fmt = box.getAttribute('data-money-format');
    var kind = box.getAttribute('data-kind');
    var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    /* Phones: right after the buy box, above the long description (the block is hidden until filled, so nothing
       shifts). Desktop keeps it between the product and the FAQ. */
    var column = document.querySelector('.product--3col .product__fastbuy-column');
    if (column && window.matchMedia('(max-width: 699px)').matches) {
      box.classList.add('fg-goes--inline');
      column.insertAdjacentElement('afterend', box);  /* order on phones is set in CSS: buy box, fiche, then this */
    }
    var url = root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=';
    var get = function (intent) { return fetch(url + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; }); };

    Promise.all([get('complementary'), get('related')]).then(function (res) {
      var picked = (res[0].products || []).map(function (p) { p.__picked = 1; return p; });
      /* Related products are "more of the same" unless filtered: drop the same kind and the family shown below. */
      var related = box.getAttribute('data-picked-only') === 'true' ? [] : (res[1].products || []).filter(function (p) {
        return firstWord(p.title) !== kind && exclude.indexOf(String(p.id)) < 0;
      });
      var seen = {};
      var items = picked.concat(related).filter(function (p) {
        if (seen[p.id] || String(p.id) === String(id) || p.available === false || !p.featured_image) return false;
        if (/sentinel/i.test(p.title)) return false;
        seen[p.id] = 1;
        return true;
      }).slice(0, 4);
      if (!items.length) return;
      familyDedupe(items.map(function (p) { return String(p.id); }));

      list.innerHTML = items.map(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        var v = avail.slice().sort(function (a, b) { return a.price - b.price; })[0] || p.variants[0];
        var single = p.variants.length === 1 && v.available;
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        return '<li class="fg-goes__item">' +
          '<a class="fg-goes__link" href="' + esc(p.url) + '" data-fg-pdp-item="goes-with">' +
            '<span class="fg-goes__img"><img src="' + esc(imgUrl(p.featured_image, 480)) + '" alt="" width="240" height="240" loading="lazy"></span>' +
            '<span class="fg-goes__text"><span class="fg-goes__name">' + esc(p.title) + '</span>' +
            '<span class="fg-goes__price' + (sale ? ' fg-goes__price--sale' : '') + '">' + money(v.price, fmt) + (p.variants.length > 1 ? ' <small>' + p.variants.length + (en ? ' options' : ' formats') + '</small>' : '') + '</span></span>' +
          '</a>' +
          (single
            ? '<button type="button" class="fg-goes__add" data-fg-goes-add="' + v.id + '" aria-label="' + esc(box.getAttribute('data-add') + ': ' + p.title) + '">' + esc(box.getAttribute('data-add')) + '</button>'
            : '<a class="fg-goes__add fg-goes__add--choose" href="' + esc(p.url) + '">' + esc(box.getAttribute('data-choose')) + '</a>') +
        '</li>';
      }).join('');
      box.hidden = false;
      send('fg_pdp_goes_with_shown', { product_id: id, count: items.length, hand_picked: items.filter(function (p) { return p.__picked; }).length });
    });

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fg-goes-add]');
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var body = new FormData();
      body.append('id', btn.getAttribute('data-fg-goes-add'));
      body.append('quantity', '1');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
      }
      fetch((window.routes && window.routes.cart_add_url) || root + 'cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j.status && j.status !== 200)) throw new Error(j.description || j.message || 'error'); return j; }); })
        .then(function (data) {
          btn.textContent = box.getAttribute('data-added');
          btn.classList.add('is-added');
          if (drawer) {
            drawer.classList.remove('is-empty');
            if (typeof drawer.renderContents === 'function') drawer.renderContents(data);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          send('fg_pdp_goes_with_add', { variant_id: btn.getAttribute('data-fg-goes-add') });
          setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2500);
        })
        .catch(function () { btn.disabled = false; window.location.href = btn.closest('li').querySelector('a').href; });
    });
  }

  /* A product shown in "Va avec" does not repeat in "Dans la même famille": drop its row, reveal a spare. */
  function familyDedupe(ids) {
    var fam = document.querySelector('.fg-fam');
    if (!fam) return;
    fam.querySelectorAll('[data-fg-fam-id]').forEach(function (row) { if (ids.indexOf(row.getAttribute('data-fg-fam-id')) > -1) row.remove(); });
    var rows = fam.querySelectorAll('[data-fg-fam-id]');
    rows.forEach(function (row, i) { if (i < 4) { row.hidden = false; row.removeAttribute('data-fg-fam-spare'); } });
    if (!rows.length) fam.hidden = true;
  }

  /* ---------- Loyalty line: follows the variant on screen ---------- */
  function points(el) {
    var rate = parseFloat(el.getAttribute('data-rate') || '0');
    var fmt = el.getAttribute('data-money-format');
    var out = el.querySelector('[data-fg-points-amount]');
    if (!rate || !out) return;
    function paint(cents) {
      var back = Math.floor(Number(cents) * rate / 100);
      /* Under 25 cents the amount says less than the rate: show the rate alone. */
      out.textContent = back >= 25 ? (en ? ', ' + money(back, fmt) + ' on this item' : ', soit ' + money(back, fmt) + ' sur cet article') : '';
    }
    paint(el.getAttribute('data-price'));
    document.addEventListener('variant:change', function (e) { var v = e.detail && e.detail.variant; if (v && v.price != null) paint(v.price); });
  }

  /* ---------- "Combien m'en faut-il ?" (snippets/fg-need-calc.liquid) ---------- */
  function num(n, d) {
    var parts = Number(n).toFixed(d || 0).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, en ? ',' : '\u00a0');
    return parts.join(en ? '.' : ',');
  }
  function needCalc(box) {
    var type = box.getAttribute('data-type');
    var a = box.querySelector('[data-fg-need-a]'), b = box.querySelector('[data-fg-need-b]');
    var out = box.querySelector('[data-fg-need-result]');
    if (!a || !out) return;
    var unit = (box.querySelector('.fg-need__unit.is-active') || {getAttribute: function () { return ''; }}).getAttribute('data-fg-need-unit');
    function button(n) {
      return ' <button type="button" class="fg-need__set" data-fg-need-set="' + n + '">' + (en ? 'Set quantity to ' + n : 'Mettre ' + n + ' dans la quantité') + '</button>';
    }
    function run() {
      var x = parseFloat(String(a.value).replace(',', '.'));
      if (!x || x <= 0) { out.hidden = true; return; }
      var n = 0, html = '';
      if (type === 'surface') {
        var per = parseFloat(box.getAttribute('data-m2'));
        var m2 = unit === 'pi2' ? x * 0.092903 : x;
        n = Math.max(1, Math.ceil(m2 / per - 1e-9));
        html = en
          ? 'For ' + num(x) + (unit === 'pi2' ? ' sq ft' : ' m²') + ' you need <b>' + n + '</b>. One covers ' + num(unit === 'pi2' ? per / 0.092903 : per) + (unit === 'pi2' ? ' sq ft.' : ' m².')
          : 'Pour ' + num(x) + (unit === 'pi2' ? ' pi²' : ' m²') + ', il vous en faut <b>' + n + '</b>. Un seul couvre ' + num(unit === 'pi2' ? per / 0.092903 : per) + (unit === 'pi2' ? ' pi².' : ' m².');
      } else if (type === 'ration') {
        var g = parseFloat(box.getAttribute('data-g')), bag = parseFloat(box.getAttribute('data-unit-grams'));
        var weeks = Math.max(1, parseInt(b && b.value, 10) || 4);
        var days = bag / (x * g);
        n = Math.max(1, Math.ceil(x * g * 7 * weeks / bag - 1e-9));
        var who = x > 1 ? box.getAttribute('data-animaux') : box.getAttribute('data-animal');
        var kg = num(bag / 1000, bag % 1000 ? 1 : 0);
        document.dispatchEvent(new CustomEvent('fg:lasts', { detail: { days: days * n } }));
        var last = days >= 14 ? (en ? 'about ' + num(days / 7, 0) + ' weeks' : 'environ ' + num(days / 7, 0) + ' semaines') : (en ? num(days, 0) + ' days' : num(days, 0) + ' jours');
        html = en
          ? 'At ' + num(g) + ' g a day each, ' + kg + ' kg feeds ' + num(x) + ' ' + who + ' for ' + last + '. For ' + weeks + ' weeks you need <b>' + n + '</b>.'
          : 'À ' + num(g) + ' g par jour chacun, ' + kg + ' kg nourrissent ' + num(x) + ' ' + who + ' pendant ' + last + '. Pour ' + weeks + ' semaines, il vous en faut <b>' + n + '</b>.';
      } else if (type === 'longueur') {
        var every = parseFloat(box.getAttribute('data-m'));
        var m = unit === 'pi' ? x * 0.3048 : x;
        n = Math.ceil(m / every - 1e-9) + 1;
        html = en
          ? 'For ' + num(x) + (unit === 'pi' ? ' ft' : ' m') + ', one every ' + num(unit === 'pi' ? every / 0.3048 : every, 1) + (unit === 'pi' ? ' ft' : ' m') + ': <b>' + n + '</b>, both ends included.'
          : 'Pour ' + num(x) + (unit === 'pi' ? ' pi' : ' m') + ', à un tous les ' + num(unit === 'pi' ? every / 0.3048 : every, 1) + (unit === 'pi' ? ' pi' : ' m') + NBSP + ': <b>' + n + '</b>, les deux bouts compris.';
      }
      out.innerHTML = html + button(n);
      out.hidden = false;
    }
    a.addEventListener('input', run);
    if (b) b.addEventListener('input', run);
    box.addEventListener('click', function (e) {
      var u = e.target.closest('[data-fg-need-unit]');
      if (u) {
        box.querySelectorAll('.fg-need__unit').forEach(function (x) { x.classList.toggle('is-active', x === u); });
        unit = u.getAttribute('data-fg-need-unit');
        run();
        return;
      }
      var set = e.target.closest('[data-fg-need-set]');
      if (set) {
        var q = parseInt(set.getAttribute('data-fg-need-set'), 10);
        document.dispatchEvent(new CustomEvent('fg:set-quantity', { detail: { quantity: q } }));
        set.textContent = en ? 'Quantity set to ' + q : 'Quantité mise à ' + q;
        send('fg_pdp_calc_used', { type: type, quantity: q });
      }
    });
  }

  /* ---------- Format picker: price per kg or litre, best value marked ----------
     Shopify's unit price first (it fills in once weights and units are set on the products); otherwise worked out
     from a format name that states the weight, only when that matches the variant's own weight.
     Single-option products only. */
  var NBSP = '\u00a0';
  function sizeOf(label) {
    var m = String(label || '').replace(',', '.').match(/(\d+(?:\.\d+)?)\s*(kg|g|lbs?|ml|l)\b/i);
    if (!m) return null;
    var q = parseFloat(m[1]), u = m[2].toLowerCase();
    if (u === 'kg') return { q: q, fam: 'kg' };
    if (u === 'g') return { q: q / 1000, fam: 'kg' };
    if (u === 'lb' || u === 'lbs') return { q: q * 0.45359237, fam: 'kg' };
    if (u === 'l') return { q: q, fam: 'L' };
    if (u === 'ml') return { q: q / 1000, fam: 'L' };
    return null;
  }
  function formatValue() {
    var picker = document.querySelector('.product--3col variant-radios, .product--3col variant-selects');
    var holder = document.querySelector('.product__fastbuy-variants');
    if (!picker || !holder) return;
    var data = picker.querySelector('script[type="application/json"]');
    var variants; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || variants.length < 2 || variants.some(function (v) { return v.option2; })) return;
    var fb = document.querySelector('[data-fg-fastbuy]');
    var fmt = fb && fb.getAttribute('data-money-format');
    var rows = variants.filter(function (v) { return v.available; }).map(function (v) {
      var m = v.unit_price_measurement;
      if (v.unit_price && m) return { name: v.option1, per: v.unit_price / (m.reference_value || 1), fam: m.reference_unit };
      /* The label only counts when it is the product's real weight: "25 kg" on a 25 kg bag, not "2 000 lb" on a
         hitch ball or "12 lb" on a feeder (capacities). So it must agree with the variant's weight within 15 %. */
      var s = sizeOf(v.option1);
      if (!s || s.fam !== 'kg' || !(s.q > 0) || !(v.weight > 0)) return null;
      if (Math.abs(v.weight - s.q * 1000) / (s.q * 1000) > 0.15) return null;
      return { name: v.option1, per: v.price / s.q, fam: 'kg' };
    }).filter(Boolean);
    if (rows.length < 2 || rows.some(function (r) { return r.fam !== rows[0].fam; })) return;
    var best = rows.slice().sort(function (x, y) { return x.per - y.per; })[0];
    var spread = rows.some(function (r) { return r.per > best.per * 1.02; });
    var p = document.createElement('p');
    p.className = 'fg-fmt';
    p.innerHTML = (en ? 'Price per ' : 'Prix au ') + esc(rows[0].fam) + NBSP + ': ' + rows.map(function (r) {
      var t = esc(r.name) + ' ' + money(Math.round(r.per), fmt);
      return r === best && spread ? '<b>' + t + (en ? ', best value' : ', le plus avantageux') + '</b>' : t;
    }).join(' · ');
    holder.appendChild(p);
  }

  /* ---------- "Me rappeler d'en racheter": one requested email, through Klaviyo ---------- */
  function reminder(box) {
    var form = box.querySelector('[data-fg-remind-form]');
    var out = box.querySelector('[data-fg-remind-result]');
    var email = box.querySelector('[data-fg-remind-email]');
    var weeks = box.querySelector('[data-fg-remind-weeks]');
    if (!form || !out || !email || !weeks) return;
    function say(ok, text) { out.className = 'fg-need__result' + (ok ? ' is-ok' : ' is-error'); out.textContent = text; out.hidden = false; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addr = String(email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(addr)) { say(false, en ? 'Enter a valid email address.' : 'Entrez une adresse courriel valide.'); email.focus(); return; }
      var k = window.klaviyo || window._learnq;
      if (!k || typeof k.push !== 'function') { say(false, en ? 'The reminder could not be saved. Please try again later.' : 'Le rappel n\u2019a pas pu être enregistré. Réessayez plus tard.'); return; }
      var w = parseInt(weeks.value, 10) || 4;
      var when = new Date(Date.now() + w * 7 * 864e5);
      var qty = (document.querySelector('.fg-fastbuy__qty-input') || {}).value || '1';
      k.push(['identify', { email: addr }]);
      k.push(['track', 'Rappel de réapprovisionnement', {
        ProductID: box.getAttribute('data-product-id'), VariantID: box.getAttribute('data-variant-id'),
        ProductName: box.getAttribute('data-title'), URL: box.getAttribute('data-url'), ImageURL: box.getAttribute('data-image'),
        Price: box.getAttribute('data-price'), Quantity: parseInt(qty, 10) || 1,
        Semaines: w, DateRappel: when.toISOString().slice(0, 10), Langue: box.getAttribute('data-lang')
      }]);
      var nice = new Intl.DateTimeFormat(en ? 'en-CA' : 'fr-CA', { day: 'numeric', month: 'long' }).format(when);
      say(true, en ? 'Done. We will write to you around ' + nice + '.' : 'C\u2019est noté. On vous écrit vers le ' + nice + '.');
      form.querySelector('button[type="submit"]').disabled = true;
      send('fg_pdp_reminder', { weeks: w });
    });
    /* The calculator knows how long a bag lasts: carry that over as the suggested interval. */
    document.addEventListener('fg:lasts', function (e) {
      var wk = Math.max(2, Math.min(12, Math.round((e.detail && e.detail.days || 0) / 7)));
      if (wk) weeks.value = String(wk);
    });
  }

  /* ---------- Desktop buy box: sticky without hiding its own bottom ----------
     The column is position: sticky under the header. When it is taller than the window, a fixed top kept its lower
     part (delivery, stock) off screen until the whole description had scrolled by. Here the top follows the scroll:
     going down, the box moves up until its bottom is in view and stays there; going up, it comes back until its
     top is under the header. A box that fits the window keeps the plain sticky behaviour. */
  function smartSticky() {
    var col = document.querySelector('.product--3col .product__fastbuy-column');
    if (!col || !window.matchMedia('(min-width: 1200px)').matches) return;
    var GAP = 16;
    /* The theme's own offset is calc(var(--header-height-top) + 2rem). Where that variable is not set the
       declaration is invalid and the column does not stick at all, so fall back to a plain 20 px. */
    function readBase() {
      col.style.top = '';
      var t = parseFloat(getComputedStyle(col).top);
      return isNaN(t) ? { v: 20, own: true } : { v: t, own: false };
    }
    var base = readBase();
    var cur = base.v, lastY = window.scrollY, ticking = false;
    function apply() {
      ticking = false;
      var y = window.scrollY, dy = y - lastY;
      lastY = y;
      var min = window.innerHeight - col.offsetHeight - GAP;
      if (min >= base.v) { cur = base.v; col.style.top = base.own ? base.v + 'px' : ''; return; }
      cur = Math.max(min, Math.min(base.v, cur - dy));
      col.style.top = cur + 'px';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { base = readBase(); cur = base.v; onScroll(); });
    if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(col);
    /* The desktop header changes height when it goes slim; the offset is read again once the theme has measured it. */
    document.addEventListener('fg:header-resize', function () { setTimeout(function () { base = readBase(); cur = base.v; onScroll(); }, 80); });
    apply();
  }

  /* ---------- Design phase D3 (docs/pdp/10-design-audit.md) ---------- */
  /* The volume offer belongs under the price, where it can change the decision. */
  function promoUnderPrice() {
    var promo = document.querySelector('.product--3col .product__fastbuy-promo');
    var price = document.querySelector('.product--3col .fg-fastbuy .fg-fastbuy__price-row');
    if (promo && price) price.insertAdjacentElement('afterend', promo);
  }
  /* ---------- Page structure (docs/pdp/19-template-structure.md) ----------
     A photo and a buy column have a fixed height; a description does not. So the first row only holds what fits
     beside the photo, and everything long goes in a details zone under it:
       row 1   photo | essentials (key points, the opening of the description) | buy column
       row 2   details: the rest of the description | every table (specifications, analysis, feeding rates…)
     The buy column spans both rows and travels with the page. Works for any product: a short description is all
     "opening" and the details zone only appears if something is left for it. */
  function words(t) { t = (t || '').replace(/ /g, ' ').trim(); return t ? t.split(/\s+/).length : 0; }
  function structure() {
    var outer = document.querySelector('.product--3col .product__outer');
    var main = outer && outer.querySelector('.product__main');
    var wrap = outer && outer.querySelector('.product__info-wrapper');
    var info = wrap && wrap.querySelector('.product__info-container');
    if (!outer || !main || !info || outer.querySelector('.fg-ess')) return;
    var about = info.querySelector('.product__about-3col');
    var desc = about && about.querySelector('.about__wrapper.no-js-hidden .about__accordion-item:first-child > .about__accordion-description');

    /* Housekeeping every description gets: paragraphs and headings with nothing in them take no room. */
    if (desc) Array.prototype.forEach.call(desc.querySelectorAll('p, h2, h3, h4, h5, div'), function (el) {
      if (!words(el.textContent) && !el.querySelector('img, video, iframe, table, svg')) el.hidden = true;
    });

    /* The table that ends the description, with its heading. */
    var box = null;
    var table = desc && desc.querySelector(':scope > table, :scope > div > table');
    if (table) {
      var block = table.parentElement === desc ? table : table.parentElement;
      var head = block.previousElementSibling;
      while (head && (head.hidden || !words(head.textContent))) head = head.previousElementSibling;
      if (head && !/^H[2-6]$/.test(head.tagName)) head = null;
      box = document.createElement('div');
      box.className = 'fg-fiche';
      if (head) { head.classList.add('fg-fiche__title'); box.appendChild(head); }
      box.appendChild(block);
      collapse(box, table.querySelectorAll('tr'), 10);
    }

    /* Essentials: key points, the staff tip, the title and the opening paragraphs (about 70 words). */
    var ess = document.createElement('div');
    ess.className = 'fg-ess';
    var glance = info.querySelector('.at-glance--desktop');
    if (glance) ess.appendChild(glance);
    var tip = info.querySelector('.fg-conseil');
    if (tip) ess.appendChild(tip);
    var lead = document.createElement('div');
    lead.className = 'fg-ess__lead';
    if (desc) {
      var count = 0, node = desc.firstElementChild;
      while (node && count < 70) {
        var next = node.nextElementSibling;
        if (node.hidden) { node = next; continue; }
        if (node.tagName !== 'P') break;
        count += words(node.textContent);
        lead.appendChild(node);
        node = next;
      }
    }
    var title = about && about.querySelector('.about__title');
    if (lead.children.length) { if (title) ess.appendChild(title); ess.appendChild(lead); }
    var rest = desc ? words(desc.textContent) : 0;
    if (about && !rest) about.hidden = true;

    /* Tables: the description's own table and the file-driven ones (analysis, feeding rates, ingredients). */
    var files = Array.prototype.slice.call(info.querySelectorAll('metafield-file-parse'));
    var aside = document.createElement('div');
    aside.className = 'fg-tables';
    var boxHome = aside;
    if (box && !rest && !files.length) boxHome = ess;   /* nothing else for the details zone: the table joins the essentials */
    files.forEach(function (f) {
      aside.appendChild(f);
      /* The rows arrive after the file is fetched: wait for them, then collapse. */
      var tries = 0;
      (function wait() {
        var items = f.querySelectorAll('.grid-blocks .grid-item');
        if (items.length && f.classList.contains('is-loaded')) return collapse(f, items, 12);
        if (++tries < 40) setTimeout(wait, 250);
      })();
    });
    if (box && boxHome === ess) ess.appendChild(box);

    var phone = window.matchMedia('(max-width: 699px)');
    function placeBox() {
      if (!box) return;
      if (phone.matches) { (outer.querySelector('.product__fastbuy-column') || main).insertAdjacentElement('afterend', box); box.classList.add('fg-fiche--phone'); }
      else { box.classList.remove('fg-fiche--phone'); if (boxHome === aside) aside.insertBefore(box, aside.firstChild); else ess.appendChild(box); }
    }
    placeBox();
    if (phone.addEventListener) phone.addEventListener('change', placeBox);

    if (aside.children.length || (box && boxHome === aside)) {
      /* Two children only, text and tables, so the travelling tables column can never slide over a block that
         follows the description (a related product, an extra section): those sit in the text column with it. */
      var text = document.createElement('div');
      text.className = 'fg-details__main';
      while (info.firstChild) text.appendChild(info.firstChild);
      info.appendChild(text);
      info.appendChild(aside);
      info.classList.add('has-tables');
      var hasText = rest > 0 || Array.prototype.some.call(text.children, function (c) { return c !== about && c.offsetHeight > 0; });
      if (!hasText) info.classList.add('only-tables');
    }
    var holder = info.querySelector('.fg-details__main') || info;
    var detailsLeft = rest > 0 || aside.children.length > 0 || Array.prototype.some.call(holder.children, function (c) { return c !== about && c !== aside && c.offsetHeight > 0; });
    wrap.classList.add('fg-details');
    if (!detailsLeft) wrap.classList.add('fg-details--empty');
    else if (rest > 0) {
      if (!wrap.id) wrap.id = 'fg-details';
      var more = document.createElement('a');
      more.className = 'fg-ess__more';
      more.href = '#' + wrap.id;
      more.textContent = en ? 'Read the full description' : 'Lire toute la description';
      ess.appendChild(more);
    }
    if (ess.children.length) main.insertAdjacentElement('afterend', ess);
    outer.classList.add('fg-structured');

    /* Beside the photo (three columns), the essentials never run past it: the opening fades into "Lire la suite",
       which opens it in place. Under the photo (narrower screens) there is nothing to match, so no cap. */
    var wide = window.matchMedia('(min-width: 1280px)');
    var opened = false;
    function cap() {
      if (opened || !lead.children.length) return;
      ess.classList.remove('fg-ess--capped');
      ess.style.maxHeight = '';
      var old = ess.querySelector('.fg-ess__expand');
      if (old) old.remove();
      if (!wide.matches) return;
      var limit = main.offsetHeight;
      if (limit < 240 || ess.scrollHeight <= limit + 24) return;
      var open = document.createElement('button');
      open.type = 'button';
      open.className = 'fg-ess__expand fg-desc__more';
      open.textContent = en ? 'Read more' : 'Lire la suite';
      open.addEventListener('click', function () { opened = true; ess.classList.remove('fg-ess--capped'); ess.style.maxHeight = ''; open.remove(); });
      lead.insertAdjacentElement('afterend', open);
      ess.classList.add('fg-ess--capped');
      ess.style.maxHeight = limit + 'px';
    }
    cap();
    if (wide.addEventListener) wide.addEventListener('change', cap);
    window.addEventListener('load', cap);
    if ('ResizeObserver' in window) { var capT; new ResizeObserver(function () { clearTimeout(capT); capT = setTimeout(cap, 150); }).observe(main); }

    /* The tables column travels beside a long description, unless it is taller than the screen. */
    function tall() { aside.classList.toggle('fg-tables--static', aside.offsetHeight > window.innerHeight - 120); }
    if (aside.children.length) { tall(); setTimeout(tall, 1500); }
  }
  /* Long tables show their first rows and a button for the rest. */
  function collapse(host, rows, keep) {
    if (!rows || rows.length <= keep + 2 || host.querySelector('.fg-fiche__all')) return;
    host.classList.add('fg-collapsed');  /* the rows are hidden by position in CSS, so a table that re-renders stays collapsed */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fg-fiche__all';
    btn.textContent = en ? 'Show all ' + rows.length + ' rows' : 'Voir les ' + rows.length + ' lignes';
    btn.addEventListener('click', function () { host.classList.remove('fg-collapsed'); btn.remove(); var col = host.closest('.fg-tables'); if (col) col.classList.add('fg-tables--static'); });
    host.appendChild(btn);
  }

  /* Phones: a long description shows its opening and a "Lire la suite" button. */
  function clampDescription() {
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    var desc = document.querySelector('.product--3col .product__about-3col .about__wrapper.no-js-hidden .about__accordion-item:first-child > .about__accordion-description');
    if (!desc || desc.scrollHeight < 460) return;
    desc.classList.add('fg-desc--clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fg-desc__more';
    btn.textContent = en ? 'Read more' : 'Lire la suite';
    btn.addEventListener('click', function () { desc.classList.remove('fg-desc--clamp'); btn.remove(); });
    desc.insertAdjacentElement('afterend', btn);
  }

  /* Price by the foot or by the kilo under the price, where the data carries it: Shopify's unit price first; else
     the length in a format name written in feet (6', 8 pi); else the weight of heavy goods (9 kg and up). */
  function feetOf(label) { var m = /^\s*(\d+(?:[.,]\d+)?)\s*(?:'|’|pi\b|pieds?\b|ft\b)/i.exec(label || ''); return m ? parseFloat(m[1].replace(',', '.')) : 0; }
  function unitLine() {
    var root = document.querySelector('.product--3col .fg-fastbuy');
    var row = root && root.querySelector('.fg-fastbuy__price-row');
    var src = root && root.querySelector('[data-fg-variants]');
    if (!row || !src) return;
    var variants; try { variants = JSON.parse(src.textContent); } catch (e) { return; }
    var fmt = (document.querySelector('[data-money-format]') || {}).getAttribute ? document.querySelector('[data-money-format]').getAttribute('data-money-format') : null;
    var line = document.createElement('p');
    line.className = 'fg-unitline';
    line.hidden = true;
    row.insertAdjacentElement('afterend', line);
    function paint(v) {
      if (!v) { line.hidden = true; return; }
      var text = '';
      if (v.unit_price && v.unit_price_measurement) {
        var um = v.unit_price_measurement;
        text = money(v.unit_price, fmt) + ' / ' + (um.reference_value !== 1 ? um.reference_value + ' ' : '') + um.reference_unit;
      } else {
        var ft = 0;
        (v.options || []).forEach(function (o) { if (!ft) ft = feetOf(o); });
        if (ft > 0) text = money(Math.round(v.price / ft), fmt) + (en ? ' per foot' : ' le pied');
        else if (v.weight >= 9000) text = money(Math.round(v.price / (v.weight / 1000)), fmt) + ' / kg';
      }
      line.textContent = text ? (en ? 'That is ' : 'Soit ') + text : '';
      line.hidden = !text;
    }
    var cur = (root.querySelector('[data-fg-variant-id]') || {}).value;
    paint(variants.filter(function (v) { return String(v.id) === String(cur); })[0] || variants[0]);
    document.addEventListener('variant:change', function (e) { if (e.detail && e.detail.variant) paint(variants.filter(function (v) { return v.id === e.detail.variant.id; })[0] || e.detail.variant); });
  }

  /* ---------- Format table: several formats in one add (snippets/fg-format-table.liquid) ---------- */
  function formatTable(box) {
    if (box.__fgTable) return;
    box.__fgTable = 1;
    /* On the product page the table lives in the buy column; in a listing's format sheet it stands alone. */
    var home = box.closest('.product__fastbuy-card');
    var card = home || box.parentNode || document;
    var picker = home ? home.querySelector('.product__fastbuy-variants') : null;
    var idx = parseInt(box.getAttribute('data-option-index') || '0', 10);
    var fmt = box.getAttribute('data-money-format');
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-fg-ftable-row]'));
    var total = box.querySelector('[data-fg-ftable-total]');
    var add = box.querySelector('[data-fg-ftable-add]');
    var msg = box.querySelector('[data-fg-ftable-msg]');
    if (!rows.length || !add) return;
    if (home) home.classList.add('has-ftable');
    /* The table takes the place of the quantity and button row, under the price. */
    var buyRow = home ? home.querySelector('.fg-fastbuy .fg-fastbuy__buy-row') : null;
    if (buyRow) buyRow.insertAdjacentElement('beforebegin', box);

    rows.forEach(function (r) {
      var ft = feetOf(r.getAttribute('data-value'));
      var unit = r.querySelector('[data-fg-ftable-unit]');
      if (ft > 0 && unit && !unit.textContent.trim()) unit.textContent = ' ' + money(Math.round(parseInt(r.getAttribute('data-price'), 10) / ft), fmt) + box.getAttribute('data-label-foot');
    });

    function input(r) { return r.querySelector('[data-fg-ftable-input]'); }
    function qty(r) { var n = parseInt(input(r).value, 10); return isNaN(n) || n < 0 ? 0 : n; }
    function selected() { return rows.filter(function (r) { return r.classList.contains('is-selected'); })[0]; }
    function setQty(r, n, quiet) {
      var max = parseInt(r.getAttribute('data-max') || '9999', 10);
      n = Math.max(0, Math.min(isNaN(n) ? 0 : n, max));
      input(r).value = n;
      r.classList.toggle('has-qty', n > 0);
      paint();
      if (!quiet && r === selected() && n > 0) document.dispatchEvent(new CustomEvent('fg:set-quantity', { detail: { quantity: n } }));
    }
    function paint() {
      var n = 0, cents = 0, lines = 0;
      rows.forEach(function (r) { var q = qty(r); if (q > 0) { n += q; lines++; cents += q * parseInt(r.getAttribute('data-price'), 10); } });
      add.disabled = n === 0;
      if (n > 1 || lines > 1) {
        total.innerHTML = '<b>' + esc(box.getAttribute('data-label-total')) + (en ? ': ' : ' : ') + money(cents, fmt) + '</b> (' + n + ' ' + esc(box.getAttribute(n > 1 ? 'data-label-items' : 'data-label-item')) + ')';
        total.hidden = false;
      } else total.hidden = true;
    }
    function mark(id) {
      rows.forEach(function (r) {
        var on = r.getAttribute('data-variant-id') === String(id);
        r.classList.toggle('is-selected', on);
        var b = r.querySelector('[data-fg-ftable-pick]');
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    /* Choosing a row selects that variant through the theme's own picker, so the photo, price and address follow. */
    function choose(r) {
      var value = r.getAttribute('data-value');
      if (picker) {
        var groups = picker.querySelectorAll('fieldset');
        var group = groups[idx];
        var radio = group && Array.prototype.filter.call(group.querySelectorAll('input[type="radio"]'), function (i) { return i.value === value; })[0];
        if (radio) { if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); } }
        else {
          var sel = picker.querySelectorAll('select')[idx];
          if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
      mark(r.getAttribute('data-variant-id'));
    }

    box.addEventListener('click', function (e) {
      var r = e.target.closest('[data-fg-ftable-row]');
      if (!r) return;
      if (e.target.closest('[data-fg-ftable-pick]')) { choose(r); if (qty(r) === 0 && !r.classList.contains('is-out')) setQty(r, 1); return; }
      if (e.target.closest('[data-fg-ftable-plus]')) return setQty(r, qty(r) + 1);
      if (e.target.closest('[data-fg-ftable-minus]')) return setQty(r, qty(r) - 1);
    });
    box.addEventListener('change', function (e) { var r = e.target.closest('[data-fg-ftable-row]'); if (r && e.target.matches('[data-fg-ftable-input]')) setQty(r, qty(r)); });
    document.addEventListener('variant:change', function (e) { if (e.detail && e.detail.variant) mark(e.detail.variant.id); });
    /* "Prenez-en 10 et c'est gratuit" and the calculator set the quantity of the format on screen. */
    document.addEventListener('fg:quantity', function (e) {
      var r = selected(), n = e.detail && e.detail.quantity;
      if (r && n > 0 && qty(r) !== n && qty(r) > 0) setQty(r, n, true);
    });

    add.addEventListener('click', function () {
      var items = rows.map(function (r) { return { id: parseInt(r.getAttribute('data-variant-id'), 10), quantity: qty(r) }; }).filter(function (i) { return i.quantity > 0; });
      if (!items.length || add.disabled) return;
      var label = add.textContent;
      add.disabled = true;
      msg.hidden = true;
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(add);
      }
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j.status && j.status !== 200)) throw new Error(j.description || j.message || 'error'); return j; }); })
        .then(function (data) {
          add.textContent = box.getAttribute('data-label-added');
          add.classList.add('is-added');
          if (drawer) { drawer.classList.remove('is-empty'); if (typeof drawer.renderContents === 'function') drawer.renderContents(data); }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          send('fg_pdp_format_table_add', { lines: items.length, units: items.reduce(function (a, i) { return a + i.quantity; }, 0) });
          setTimeout(function () { add.textContent = label; add.classList.remove('is-added'); add.disabled = false; paint(); }, 2200);
        })
        .catch(function (err) {
          add.disabled = false;
          msg.textContent = err && err.message && err.message !== 'error' ? err.message : (en ? 'Could not add to the cart. Please try again.' : 'Ajout impossible pour le moment. Réessayez.');
          msg.hidden = false;
        });
    });
    rows.forEach(function (r) { r.classList.toggle('has-qty', qty(r) > 0); });
    paint();
  }

  /* ---------- Design phase D4: motion and feedback ---------- */
  /* The cart icon answers every add on this page (buy box and "Va avec" both announce cart:refresh). */
  function cartBump() {
    document.addEventListener('cart:refresh', function () {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      bubble.classList.remove('fg-bump');
      void bubble.offsetWidth;
      bubble.classList.add('fg-bump');
    });
  }
  /* ---------- Buy bar (docs/pdp/20-all-widths-audit.md, 2) ----------
     On phones and tablets the buy column does not travel, and the add button sits more than a screen down.
     Whenever that button is out of view, a slim bar above the bottom navigation carries the price and the action.
     It presses the page's own button, so the format, quantity and subscription on screen are what is added. */
  function buyBar() {
    var root = document.querySelector('.product--3col .fg-fastbuy');
    if (!root || document.querySelector('.fg-buybar')) return;
    var table = document.querySelector('.product--3col [data-fg-ftable]');
    var target = table ? table.querySelector('[data-fg-ftable-add]') : root.querySelector('.fg-fastbuy__atc');
    if (!target) return;
    var narrow = window.matchMedia('(max-width: 1279px)');
    var title = (document.querySelector('.product__fastbuy-title') || {}).textContent || '';
    var bar = document.createElement('div');
    bar.className = 'fg-buybar';
    bar.hidden = true;
    bar.innerHTML = '<span class="fg-buybar__info"><span class="fg-buybar__title">' + esc(title.trim()) + '</span><span class="fg-buybar__price"></span></span><button type="button" class="fg-buybar__btn"></button>';
    var price = bar.querySelector('.fg-buybar__price'), btn = bar.querySelector('.fg-buybar__btn');
    document.body.appendChild(bar);
    var inView = true;
    function paint() {
      var p = root.querySelector('.fg-fastbuy__option.is-selected .fg-fastbuy__option-price') || root.querySelector('.fg-fastbuy__price-current') || document.querySelector('.product__fastbuy-price > span:first-child');
      price.textContent = p ? p.textContent.trim() : '';
      var label = table ? (en ? 'Choose a format' : 'Choisir le format') : ((target.querySelector('.fg-fastbuy__atc-text') || target).textContent || '').trim();
      btn.textContent = label;
      btn.classList.toggle('is-off', !table && target.disabled);
      var nav = document.querySelector('.bottom-nav');
      bar.style.bottom = (nav && nav.offsetHeight && getComputedStyle(nav).position === 'fixed' ? nav.offsetHeight : 0) + 'px';
      var drawerOpen = !!document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active');
      bar.hidden = !(narrow.matches && !inView && !drawerOpen);
    }
    /* Measured on scroll rather than observed: the answer is needed at once, also in a background tab. */
    var ticking = false;
    function check() {
      ticking = false;
      var r = target.getBoundingClientRect();
      var now = r.height > 0 && r.top < window.innerHeight - 20 && r.bottom > 60;
      if (now !== inView) { inView = now; paint(); }
    }
    function onScroll() { if (!ticking) { ticking = true; setTimeout(check, 60); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    inView = false;
    btn.addEventListener('click', function () {
      if (table || target.disabled) { (table || target).scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      target.click();
      send('fg_pdp_buybar_add', {});
    });
    document.addEventListener('variant:change', function () { setTimeout(paint, 200); });
    root.addEventListener('change', function () { setTimeout(paint, 200); });
    document.addEventListener('cart:refresh', function () { setTimeout(paint, 400); });
    if (narrow.addEventListener) narrow.addEventListener('change', paint);
    check();
    paint();
    setTimeout(function () { check(); paint(); }, 1200);
  }

  window.FGFormatTable = formatTable;

  function start() {
    cartBump();
    promoUnderPrice();
    structure();
    clampDescription();
    unitLine();
    document.querySelectorAll('[data-fg-ftable]').forEach(formatTable);
    buyBar();
    smartSticky();
    document.querySelectorAll('[data-fg-remind]').forEach(reminder);
    document.querySelectorAll('[data-fg-goes]').forEach(goesWith);
    document.querySelectorAll('[data-fg-points]').forEach(points);
    document.querySelectorAll('[data-fg-need]').forEach(needCalc);
    formatValue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
